import { Account, RefdataService } from './shared/refdata.service';
import { Component, ElementRef, ViewChild, AfterViewInit, ViewContainerRef, OnInit, ChangeDetectorRef } from '@angular/core';

import { AuthenticationService, User, ISecUiConfig, AppSettingsService, ServiceManager, BaseAppComponent } from 'iui-iconectiv-lib';
import { Router, NavigationEnd } from '@angular/router';
import { Roles, Activities } from './shared';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'primeng/api/message';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';

import { SummaryService } from '././summary/summary.service';

declare function require(name: string);
import * as moment from 'moment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent extends BaseAppComponent implements OnInit,AfterViewInit {

  public alerts: Message[] = [];

  title = 'TruNumber Finder';
  shortTitle = 'TruNumber Finder';
  brandImage = "assets/images/iconectiv_microsite_header.png";
  q = '';
  accountType: string;
  ws: Subject<MessageEvent>;
  showLoader = true;
  outstandingRequests = 0;
  year = 2017;
  showProfileImage = false;
  showPrivacy = true;
  showAccessStatement = true;
  showAdmin = false;
  showManageDelegates = false;
  showManageAccount = false;
  showManageUsers = false;
  showSecurity = false;
  showCampaignList = false;
  showTestsnmp = false;
  showHelp = false;
  showReports = false;
  showExtendedProfile = false;
  myAccount: any;
  accountStatus: string;
  apphome: string;
  contactUrl: string;
  faqUrl: string;
  customerSupportUrl: string;
  reportAccess = false;

  constructor(serviceManager: ServiceManager,
    private isecConfig: ISecUiConfig,
    public authService: AuthenticationService,
    private appSettings: AppSettingsService,
    private router: Router,
    private viewContainerRef: ViewContainerRef,
    private summaryService: SummaryService,
    private refdataService: RefdataService,
    private cdRef: ChangeDetectorRef) {

    super(serviceManager, undefined);

    //this is to do not log debug statements on initial load
    this.log.enabled=false;

    // This small hack is here because angular2 UI needs it for some reason.
    this.viewContainerRef = viewContainerRef;

    this.setUser(this.authService.getUser());

    const dt = new Date();
    this.year = dt.getFullYear();

    this.translate.defaultLang = 'en';
    this.translate.use('en');

    /**
     * Subscribe to the auth service for updates to the user.
     */
    this.authService.userChangeEvent.subscribe(u => {
      this.setUser(u as User);
    });

    this.appSettings.getSettings().subscribe(s => {
      this.showTestsnmp = s['testsnmp'];
      this.log.debug('showTestsnmp=' + this.showTestsnmp);
      if (s.apphome) {
        this.apphome = s.apphome;
        this.contactUrl = this.apphome + "/contact-finder";
        this.faqUrl = this.apphome + "/faq-finder";
      }

     });
     this.year = 2023;
     
  }
  
  
  ngOnInit() {
    /**
     * Angular does not scroll to the top of the page when you navigate between
     * pages.  If you are scrolled down on the campaign info page and navigate to
     * manage profile, you end up in the middle of the page.
     */
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    this.refdataService.getRefdata().subscribe(rd => {
      this.customerSupportUrl = rd.customerSupportUrl;
     });

    

  }

  ngAfterViewInit(): void {
    this.cdRef.detectChanges(); 
  }

  

  fakeSessionTimeout() {
    this.authService.fakeSessionTimeout(-60);
  }

  /**
   * Called when the user is assigned or changed.
   */
  setUser(u: User) {
    this.log.debug('set user ' + JSON.stringify(u));
    

    if (u) {
     // if (u.appaccount) {
      //  this.accountType = u.appaccount.accountType;
      

      if (this.myAccount != null) {
        this.accountStatus = this.myAccount['status'];
        
       }
       
        

       this.showAdmin = this.authService.hasRole([Roles.CustomerAdmin]) ;
        this.showManageAccount = this.authService.hasRole([Roles.CustomerAdmin]);
        this.showManageUsers = this.authService.hasRole([Roles.CustomerAdmin]);
        this.showHelp = true;
       
     // }
      // this.fetchProfileImage();
     
      this.appSettings.getSettings().subscribe(settings => {
        if (u.roles.find(r => r === Roles.ServiceDesk) !== undefined) {
          settings.productName = 'TruNumber Finder Service Desk';
          this.showPrivacy = false;
          this.showAccessStatement = false;
          this.showReports = true;
          this.getAccountStatus();
         }
        else {
          settings.productName = 'TruNumber Finder';
          this.showPrivacy = true;
          this.showAccessStatement = true;
         
          
          
          this.getAccountStatus();
          
        }
        this.title = settings.productName;

      });

      this.isecConfig.showExtendedProfile = true;
      

    }
    else {
      this.showAdmin = false;
      this.showManageDelegates = false;
      this.showSecurity = false;
      this.showCampaignList = false;
      this.showProfileImage = false;
      this.showHelp = false;
      this.reportAccess = false;
      this.showReports = false;
      this.isecConfig.showExtendedProfile = true;
      delete this.accountType;
      if (this.ws) {
        this.log.debug('user undefined - will close ws');
        this.ws = undefined;
      }
      this.clearFilters();
    }
    

  }


 getAccountStatus() {
  this.myAccount = null;
    this.summaryService.getMyAccount().subscribe(
      resp => {
         this.myAccount = resp['Account'] || null;
        //  console.log("myAccount: " + this.myAccount)
        //  console.log(`verifyAccountStatus(): data=${JSON.stringify(this.myAccount['reportAccess'])}`);
        if (this.myAccount.reportAccess) {
          this.reportAccess = this.myAccount['reportAccess'] || false;
        }
      }

    );
  }

    ///finder/help/adminreports/index.htm
  getHelpUrl() {
    let report = "";
    if (this.reportAccess) {
      report = "report";
    }
    if (this.authService.hasRole([Roles.CustomerAdmin]))
       window.open('/finder/help/admin' + report +'/index.htm');
    else if (this.authService.hasRole([Roles.CustomerUser]))
      window.open('/finder/help/user' + report +'/index.htm');
    else if (this.authService.hasRole([Roles.ServiceDesk]))
      window.open('/finder/help/servicedesk/index.htm');

       return false;
  }


  public register() {
    this.router.navigate(['/register']);

  }

  getRouteUrl(): string {
    const rv = this.router.url;
    const idx = rv.indexOf('?');
    if (idx >= 0) {
      return rv.substr(0, idx);
    }
    return rv;
  }

  // clear SD filter when logged out
  clearFilters() {
    sessionStorage.removeItem("filterSettings");
    sessionStorage.removeItem("sortSettings");
  }


  getCustomerSupportUrl(){
     window.open("/contact-finder");
  }

  getFaqUrl(){
    let report = "";
    if (this.reportAccess) {
      report = "report";
    }
    if (this.authService.hasRole([Roles.CustomerAdmin]))
       window.open('/finder/help/faqadmin' + report + '/index.htm');
    else if (this.authService.hasRole([Roles.CustomerUser]))
      window.open('/finder/help/faquser' + report +'/index.htm');
       return false;
  }

}


